import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3143, { U3143ROLES } from "./U3143";
import U3143DistrictCadastreList from "./components/U3143DistrictCadastreList";
import U3143DistrictCadastreForm from "./components/U3143DistrictCadastreForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3143Routes: RouteObject[] = [
  {
    path: "U3143",
    element: <U2000RequireRole allowedRoles={[U3143ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3143 />,
        children: [
          { index: true, element: <U3143DistrictCadastreList /> },
          { path: ":id", element: <U3143DistrictCadastreForm /> },
        ],
      },
    ],
  },
];

export default U3143Routes;
